/* Bean Shipper · Equipment collection (sections/collection__bs-equipment.liquid), 25 Sep 2026.
   Step tabs (Grind · Brew · Espresso), maker chips, sort (featured, top rated, price, A-Z), live
   counts, reveal on scroll and quick-add feedback. Filter state rides in the URL (?step= &maker=
   &order=) so a filtered view can be shared, and the hero button ("Start with a grinder") opens the
   Grind tab. Adding to the bag is the theme's job: bean-shipper.js listens for [data-bs-quick-add]
   clicks; this file only mirrors the result on the button, read from the toast that script shows.
   The reveal moves cards only and never touches opacity (theme rule). Without this file every card
   still renders, links and adds. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bseq]');
  if (!root || root.getAttribute('data-bseq-ready')) return;
  root.setAttribute('data-bseq-ready', '1');

  function all(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  var grid = root.querySelector('[data-bseq-grid]');
  var cells = grid ? all('[data-bseq-card]', grid) : [];
  var tabs = all('[data-bseq-step]');
  var makerChips = all('[data-bseq-maker]');
  var clearBtns = all('[data-bseq-clear]');
  var chipClear = root.querySelector('.bseq__clear');
  var sortSels = all('[data-bseq-sort]');
  var countEl = root.querySelector('[data-bseq-count]');
  var emptyEl = root.querySelector('[data-bseq-empty]');
  var main = root.querySelector('.bseq__main');
  var tools = root.querySelector('.bseq__tools');
  var bar = root.querySelector('[data-bseq-bar]');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var STEPS = { all: 1 };
  tabs.forEach(function (t) { STEPS[t.getAttribute('data-bseq-step')] = 1; });
  var MAKERS = {};
  makerChips.forEach(function (c) { MAKERS[c.getAttribute('data-bseq-maker')] = 1; });
  var SORTS = { featured: 1, rated: 1, low: 1, high: 1, az: 1 };
  var state = { step: 'all', maker: '', sort: 'featured' };

  try {
    var q = new URLSearchParams(window.location.search);
    if (STEPS[q.get('step')]) state.step = q.get('step');
    if (MAKERS[q.get('maker')]) state.maker = q.get('maker');
    if (SORTS[q.get('order')]) state.sort = q.get('order');
  } catch (e) {}

  function stepOk(cell, step) { return step === 'all' || cell.getAttribute('data-step') === step; }
  function makerOk(cell) { return !state.maker || cell.getAttribute('data-maker') === state.maker; }
  function num(cell, attr) { return parseFloat(cell.getAttribute(attr)) || 0; }
  function byPos(a, b) { return num(a, 'data-pos') - num(b, 'data-pos'); }
  var sorters = {
    featured: byPos,
    rated: function (a, b) { return (num(b, 'data-rating') - num(a, 'data-rating')) || (num(b, 'data-reviews') - num(a, 'data-reviews')) || byPos(a, b); },
    low: function (a, b) { return (num(a, 'data-price') - num(b, 'data-price')) || byPos(a, b); },
    high: function (a, b) { return (num(b, 'data-price') - num(a, 'data-price')) || byPos(a, b); },
    az: function (a, b) { return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || ''); }
  };

  var io = null;
  function columns() {
    if (!grid) return 1;
    var t = (window.getComputedStyle(grid).gridTemplateColumns || '').split(' ');
    var n = 0;
    for (var i = 0; i !== t.length; i++) { if (t[i] && t[i] !== '0px') n++; }
    return n || 1;
  }
  function reveal(visible) {
    if (reduce || !('IntersectionObserver' in window)) {
      visible.forEach(function (c) { c.classList.add('is-in'); });
      return;
    }
    if (io) io.disconnect();
    var cols = columns();
    visible.forEach(function (c, i) {
      c.classList.remove('is-in');
      c.style.setProperty('--d', ((i % cols) * 80) + 'ms');
    });
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    visible.forEach(function (c) { io.observe(c); });
  }

  function writeUrl() {
    try {
      var u = new URL(window.location.href);
      var put = function (k, v, dflt) { if (v && v !== dflt) u.searchParams.set(k, v); else u.searchParams.delete(k); };
      put('step', state.step, 'all');
      put('maker', state.maker, '');
      put('order', state.sort, 'featured');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function keepInView() {
    if (!tools || !bar) return;
    var barBottom = bar.getBoundingClientRect().bottom;
    var top = tools.getBoundingClientRect().top;
    if (top >= barBottom) return;
    var y = window.pageYOffset + top - barBottom - 12;
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }

  function press(el, on) {
    el.classList.toggle('is-on', on);
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function apply(initial) {
    var visible = [];
    cells.forEach(function (c) {
      var ok = stepOk(c, state.step) && makerOk(c);
      c.hidden = !ok;
      if (ok) visible.push(c);
    });
    var order = sorters[state.sort] || byPos;
    if (grid) {
      var frag = document.createDocumentFragment();
      cells.slice().sort(order).forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
      grid.hidden = visible.length === 0;
    }
    visible.sort(order);

    tabs.forEach(function (tab) {
      var s = tab.getAttribute('data-bseq-step');
      var n = 0;
      cells.forEach(function (c) { if (stepOk(c, s) && makerOk(c)) n++; });
      var el = tab.querySelector('[data-bseq-n]');
      if (el) el.textContent = String(n);
      press(tab, s === state.step);
    });
    makerChips.forEach(function (c) { press(c, c.getAttribute('data-bseq-maker') === state.maker); });

    if (chipClear) chipClear.hidden = !(state.step !== 'all' || state.maker);
    if (countEl) countEl.textContent = visible.length + (visible.length === 1 ? ' tool' : ' tools');
    if (emptyEl) emptyEl.hidden = visible.length !== 0;
    sortSels.forEach(function (sel) { if (sel.value !== state.sort) sel.value = state.sort; });

    reveal(visible);
    if (!initial) { writeUrl(); keepInView(); }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { state.step = tab.getAttribute('data-bseq-step'); apply(false); });
  });
  makerChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var m = chip.getAttribute('data-bseq-maker');
      state.maker = state.maker === m ? '' : m;
      apply(false);
    });
  });
  clearBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.step = 'all'; state.maker = ''; apply(false); });
  });
  sortSels.forEach(function (sel) {
    sel.addEventListener('change', function () { state.sort = SORTS[sel.value] ? sel.value : 'featured'; apply(false); });
  });

  /* Hero button: open a step's tab and bring the grid up under the sticky bar, in place. */
  all('[data-bseq-go]', document).forEach(function (a) {
    a.addEventListener('click', function (e) {
      var s = a.getAttribute('data-bseq-go');
      if (!STEPS[s]) return;
      e.preventDefault();
      state.step = s;
      state.maker = '';
      apply(true);
      writeUrl();
      if (main) {
        var y = window.pageYOffset + main.getBoundingClientRect().top - (bar ? bar.getBoundingClientRect().height : 56) - (parseFloat(window.getComputedStyle(root).getPropertyValue('--top')) || 0) + 8;
        try { window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' }); } catch (err) { window.scrollTo(0, y); }
      }
    });
  });

  /* The theme header is position:fixed. Park the filter bar right under whatever part of it is on
     screen, so it never tucks behind the header or floats below a header that has moved away. */
  var header = document.querySelector('header.nav') || document.querySelector('[data-bs-header]');
  var lastTop = -1;
  var ticking = false;
  function syncTop() {
    ticking = false;
    if (!header) return;
    var b = Math.round(header.getBoundingClientRect().bottom);
    if (b > 0 && b <= 200) { if (b !== lastTop) { lastTop = b; root.style.setProperty('--top', b + 'px'); } }
    else if (lastTop !== 0) { lastTop = 0; root.style.setProperty('--top', '0px'); }
  }
  function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(syncTop); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  syncTop();

  /* Quick-add feedback: bean-shipper.js posts to /cart/add.js, opens the drawer and shows a
     .bs-toast; its is-error class marks a failed add. */
  function setLabel(btn, longText, shortText) {
    var l = btn.querySelector('[data-bseq-qa-l]');
    var s = btn.querySelector('.bseq-card__qa-s');
    if (l) l.textContent = longText;
    if (s) s.textContent = shortText;
  }
  function watchToast(done) {
    if (!('MutationObserver' in window)) { done(null); return; }
    var finished = false;
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (finished || !n.classList || !n.classList.contains('bs-toast')) return;
          finished = true;
          mo.disconnect();
          done(!n.classList.contains('is-error'));
        });
      });
    });
    mo.observe(document.body, { childList: true });
    window.setTimeout(function () { if (!finished) { finished = true; mo.disconnect(); done(null); } }, 6000);
  }
  root.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bseq-qa]') : null;
    if (!btn || btn.classList.contains('is-busy')) return;
    if (!btn._bseqText) {
      var l = btn.querySelector('[data-bseq-qa-l]');
      var s = btn.querySelector('.bseq-card__qa-s');
      btn._bseqText = [l ? l.textContent : '', s ? s.textContent : ''];
    }
    var orig = btn._bseqText;
    btn.classList.remove('is-added');
    btn.classList.add('is-busy');
    setLabel(btn, 'Adding…', 'Adding…');
    watchToast(function (ok) {
      btn.classList.remove('is-busy');
      if (ok) {
        btn.classList.add('is-added');
        setLabel(btn, 'Added to bag', 'Added');
        window.setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, orig[0], orig[1]); }, 1600);
      } else {
        setLabel(btn, orig[0], orig[1]);
      }
    });
  });

  root.classList.add('bseq--js');
  apply(true);
  window.setTimeout(function () {
    var vh = window.innerHeight;
    cells.forEach(function (c) {
      if (c.hidden || c.classList.contains('is-in')) return;
      var r = c.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) c.classList.add('is-in');
    });
  }, 1500);
})();
